// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoOutlinedSvg from "@fishx/icons-svg/es/asn/TaobaoOutlined";
import FishxIcon from '../components/FishxIcon';

var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoOutlinedSvg
  }));
};

TaobaoOutlined.displayName = 'TaobaoOutlined';
export default React.forwardRef(TaobaoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TaobaoOutlined.js
// module id = 4245
// module chunks = 0